/**
 * Reads the current user's household_id from localStorage.
 * Returns null when missing or empty so call sites can pass a JSONable
 * value straight to error-log / chat payloads.
 *
 * Sync, non-hook accessor — use this from class components, plain utility
 * modules, and axios interceptors where useAuth() isn't available. From
 * functional React components, prefer reading household_id from auth
 * context if it's exposed there.
 *
 * @returns {string | null}
 */
export const getStoredHouseholdId = () =>
    localStorage.getItem('household_id') || null;

export const AUTH_SESSION_STORAGE_KEY = {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    CALENDLY_LINK: 'calendly_link',
};

export const AUTH_SESSION_STORAGE_KEYS = Object.values(AUTH_SESSION_STORAGE_KEY);

export const clearStoredAuthSession = () => {
    AUTH_SESSION_STORAGE_KEYS.forEach((key) => {
        localStorage.removeItem(key);
    });
};
